'use client';

import Conditional from '@next-app/components/Conditional';
import { isNotNullOrUndefinedorEmpty } from '@next-app/utils/common-utils';
import { ReactNode } from 'react';
import parse from 'html-react-parser';

interface LLCheckboxProps {
  children: ReactNode;
  testId?: string;
  customClass?: string;
  errorMsg?: string;
  automationId?: string;
}

const LLCheckbox: React.FC<
  React.InputHTMLAttributes<HTMLInputElement> & LLCheckboxProps
> = ({
  id,
  checked,
  disabled,
  children,
  testId,
  automationId,
  onChange,
  customClass,
  errorMsg = '',
}) => {
  return (
    <>
      <div className={`form-check ${customClass}`}>
        <input
          className="form-check-input mt-0 ll-link-cursor"
          type="checkbox"
          value=""
          id={id}
          checked={checked}
          disabled={disabled}
          data-testid={testId}
          automation-id={automationId}
          onChange={onChange}
        />
        <label className="form-check-label ll-link-cursor" htmlFor={id}>
          {children}
        </label>
      </div>
      <Conditional if={isNotNullOrUndefinedorEmpty(errorMsg)}>
        <div className="invalid-feedback d-block">
          <p dangerouslySetInnerHTML={{ __html: parse(errorMsg) }}></p>
        </div>
      </Conditional>
    </>
  );
};

export default LLCheckbox;
